// 3-status workflow: New (1), In Progress (2), Completed (4).
// Legacy statuses 3 (Ready for Review) and 5 (In Revision/Pending Customer Review)
// are intentionally excluded from PM dropdowns but remain valid backend IDs for old documents.
export const documentStatus = [
  {
    id: 1,
    label: "New",
  },
  {
    id: 2,
    label: "In Progress",
  },
  {
    id: 4,
    label: "Completed",
  },
];

export const columnMinWidth: any = {
  language: 150,
  document_status_id: 220,
  document_original_file_name: 260,
  translators: 200,
  managers: 220,
  actionCol: 200,
};

export const downloadFile = (filePath: string, fileName: string) => {
  const fullUrl =
    filePath?.includes("http://") || filePath?.includes("https://")
      ? filePath
      : `${process.env.REACT_APP_API_BASE_URL}/${filePath}/${fileName}`;
  
  const link = document.createElement("a");
  link.href = fullUrl;
  link.target = "_blank";
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export const getTranslatorsByLanguage = (translators: any[], sourceLanguage: string, targetLanguage: string) => {
  const searchLanguage = sourceLanguage === "English" ? targetLanguage : sourceLanguage;
  return translators?.filter((translator: any) => {
    const languages = translator.languages;
    return languages.filter(({ language }: any) => language === searchLanguage).length > 0;
  });
};
